module.exports = __webpack_public_path__ + "media/images/recruitment/landing/client05-bd4a76d22cb1edf268a3698f9fa7f849.png";